<div class="profil-page">
  <header class="profile-header">
    <button type="button" class="back-button" (click)="goBack()" aria-label="Retour">
      <span>‹</span>
    </button>
    <h1 class="page-title">Mon profil saloon</h1>
    <div class="header-spacer" aria-hidden="true"></div>
  </header>
  <div class="profil-content">
    <app-my-profil></app-my-profil>
  </div>
  <app-navbar></app-navbar>
</div>
